import React, { Component } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import CreateChurchPage from "./churchCreate";
import EditChurchPage from "./churchEdit";
import ChurchList from "./churchList";
import './churchList.css';

export default class ChurchesPage extends Component {
  createChurchPage = (props) => {
    return <CreateChurchPage {...props} selectedChurch={this.props.selectedChurch}/>
  };

  editChurchPage = (props) => {
    return <EditChurchPage {...props} selectedChurch={this.props.selectedChurch}/>
  };

  churchList = (props) => {
    return <ChurchList {...props} selectedChurch={this.props.selectedChurch}/>
  };

  render() {
    return (
      <div>
        <div className="dashboard-layout__placeholder"/>
        <div className="m-24">
          <Route exact path={`${this.props.match.url}`} render={this.churchList}/>
          <Route exact path={`${this.props.match.url}/new`} render={this.createChurchPage}/>
          <Route exact path={`${this.props.match.url}/edit/:churchId`} render={this.editChurchPage}/>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/churches/churches.js